export const PRODUCT_VERSION = 'PRODUCT_VERSION';
export const QUANTITY_PACK = 'QUANTITY_PACK';